import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import { Toaster } from "sonner";
import i18n from "./i18n";
import { AuthProvider } from "./contexts/AuthContext";
import ErrorBoundary from "@/components/base/ErrorBoundary";

function App() {
  return (
    <ErrorBoundary>
      <I18nextProvider i18n={i18n}>
        <AuthProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <AppRoutes />
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </I18nextProvider>
    </ErrorBoundary>
  );
}

export default App;